<up-bs-modal [config]="bsModalConfig" (modalEvent)="handleModalEvent($event)">
  <div>
    <span data-automation-id="token-error-text">
      {{ modalBody | translate }}
    </span>
  </div>
</up-bs-modal>
